import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";
import { Link } from "react-router-dom";

export default function Featured() {
  const featured = comics.filter((c) => c.featured).slice(0, 6);

  return (
    <section className="container-site py-16 md:py-20">
      <div className="mb-8 flex items-end justify-between">
        <div>
          <p className="inline-flex items-center gap-2 text-xs font-medium text-primary-600">
            <i className="ri-fire-fill text-accent-500"></i>
            本周精选
          </p>
          <h2 className="mt-2 text-2xl font-semibold text-foreground-950 md:text-3xl">
            编辑推荐 · 高分佳作
          </h2>
        </div>
        <Link
          to="/category/all"
          className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-500 sm:inline-flex cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-6">
        {featured.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}